import { put, call, takeLatest } from "redux-saga/effects";
import {
  insertCategoryRequest,
  insertCategorySuccess,
  insertCategoryFailure,
  editCategoryRequest,
  editCategorySuccess,
  editCategoryFailure,
  insertSubCategoryRequest,
  insertSubCategorySuccess,
  insertSubCategoryFailure,
  getSubcategoryRequest,
  getSubcategorySuccess,
  getSubcategoryFailure,
  editSubCategoryRequest,
  editSubCategorySuccess,
  editSubCategoryFailure,
  getProductbysubcategoryRequest,
  getProductbysubcategorySuccess,
  getProductbysubcategoryFailure,
  deleteCategoryRequest,
  deleteCategorySuccess,
  deleteCategoryFailure,
  deleteSubCategoryRequest,
  deleteSubCategorySuccess,
  deleteSubCategoryFailure,
  getsubcategorybycategoryidRequest,
  getsubcategorybycategoryidSuccess,
  getsubcategorybycategoryidFailure,
} from "./Category-slice";
import { API_URL } from "../../utils/Api";
import axiosInstance from "../../utils/AxiosConfig";

function* insertCategorySaga(action) {
  try {
    const response = yield axiosInstance.get(`createCategory`, {
      params: action.payload,
    });
    yield put(insertCategorySuccess(response.data));
  } catch (error) {
    yield put(insertCategoryFailure(error.message));
  }
}

export function* watchinsertCategory() {
  yield takeLatest(insertCategoryRequest.type, insertCategorySaga);
}

function* editCategorySaga(action) {
  // for (let [key, value] of action.payload.entries()) {
  //   console.log(key, value);
  // }
  try {
    const response = yield axiosInstance.post(
      `updateCategory`,
      action.payload,
      {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      }
    );
    // console.log("response", response);
    yield put(editCategorySuccess(response.data));
  } catch (error) {
    yield put(editCategoryFailure(error.message));
  }
}

export function* watcheditCategory() {
  yield takeLatest(editCategoryRequest.type, editCategorySaga);
}

function* subCategorySaga(action) {
  // for (let [key, value] of action.payload.entries()) {
  //   console.log(key, value);
  // }
  try {
    const response = yield axiosInstance.post(
      `createSubCategory`,
      action.payload,
      {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      }
    );
    yield put(insertSubCategorySuccess(response.data));
  } catch (error) {
    yield put(insertSubCategoryFailure(error.message));
  }
}

export function* watchsubCategory() {
  yield takeLatest(insertSubCategoryRequest.type, subCategorySaga);
}

function* getSubcategorySaga(action) {
  try {
    const response = yield axiosInstance.get(`getSubCategories`, {
      params: action.payload,
    });
    yield put(getSubcategorySuccess(response.data));
  } catch (error) {
    yield put(getSubcategoryFailure(error.message));
  }
}

export function* watchgetSubcategory() {
  yield takeLatest(getSubcategoryRequest.type, getSubcategorySaga);
}

function* editSubCategorySaga(action) {
  // for (let [key, value] of action.payload.entries()) {
  //   console.log(key, value);
  // }
  try {
    const response = yield axiosInstance.post(
      `updateSubCategory`,
      action.payload,
      {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      }
    );
    // console.log("response", response);
    yield put(editSubCategorySuccess(response.data));
  } catch (error) {
    yield put(editSubCategoryFailure(error.message));
  }
}

export function* watcheditSubCategory() {
  yield takeLatest(editSubCategoryRequest.type, editSubCategorySaga);
}

function* getProductbysubcategorySaga(action) {
  try {
    const response = yield axiosInstance.get(
      `getproductsByCategoryId/${action.payload}`
    );
    yield put(getProductbysubcategorySuccess(response.data));
  } catch (error) {
    yield put(getProductbysubcategoryFailure(error.message));
  }
}

export function* watchgetProductbysubcategory() {
  yield takeLatest(
    getProductbysubcategoryRequest.type,
    getProductbysubcategorySaga
  );
}

function* deleteCategorySaga(action) {
  try {
    const response = yield axiosInstance.delete(
      `deleteCategory/${action.payload}`
    );
    yield put(deleteCategorySuccess(response.data));
  } catch (error) {
    yield put(deleteCategoryFailure(error.message));
  }
}

export function* watchdeleteCategory() {
  yield takeLatest(deleteCategoryRequest.type, deleteCategorySaga);
}

function* deleteSubCategorySaga(action) {
  try {
    const response = yield axiosInstance.delete(
      `deleteSubCategory/${action.payload}`
    );
    yield put(deleteSubCategorySuccess(response.data));
  } catch (error) {
    yield put(deleteSubCategoryFailure(error.message));
  }
}

export function* watchdeleteSubCategory() {
  yield takeLatest(deleteSubCategoryRequest.type, deleteSubCategorySaga);
}

function* getsubcategorybycategoryidSaga(action) {
  try {
    const response = yield axiosInstance.get(
      `getSubCategoriesByCategoryId/${action.payload}`
    );
    yield put(getsubcategorybycategoryidSuccess(response.data));
  } catch (error) {
    yield put(getsubcategorybycategoryidFailure(error.message));
  }
}

export function* watchgetsubcategorybycategoryid() {
  yield takeLatest(
    getsubcategorybycategoryidRequest.type,
    getsubcategorybycategoryidSaga
  );
}
